import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

type MarketingPlatformFilterEvent = {
    topic: string;
    elementType?: string;
    eventAction?: string;
    platform?: string;
    [key: string]: unknown;
};

export class MarketingAnalyticsPlatformFilterClickType extends MarketingAnalyticsEventType {
    canHandle(event: MarketingPlatformFilterEvent): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CLICK && event.elementType === 'platformFilter';
    }

    getBody(event: MarketingPlatformFilterEvent): MarketingAnalyticsEvent {
        return {
            ...this.baseEvent(event),
            event_type: 'Platform Filter Click',
            action: event.eventAction,
        };
    }
}
